import React, { useEffect, useState, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import config from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faSave, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import PopupService from '../PopupService';
import { useApi } from '../../ApiContext';
import { format } from 'date-fns';
import { apiFetch } from '../utils/ApiFetch';

const ResolveRouting = () => {
	const [clients, setClients] = useState([]); 
	const [loading, setLoading] = useState(true);
	const [selectedClientId, setSelectedClientId] = useState('');
	const [selectedDomainName, setSelectedDomainName] = useState('');
	const username = sessionStorage.getItem("username");
	const mrToken = localStorage.getItem("mr_token");
	const { callApi, setIsApiLoading } = useApi();
	const [activeTab, setActiveTab] = useState('alerts');
	const summaryRef = useRef(null);
	const [showNodeSelectionCard, setShowNodeSelectionCard] = useState(false);
	const [selectedMrNumber, setSelectedMrNumber] = useState('');
	const [domainList, setDomainList] = useState([]);
	const [subDomainEnabled, setSubDomainEnabled] = useState({});
	const [subDomainLists, setSubDomainLists] = useState({});
	const [showTree, setShowTree] = useState(false);
	const [resolverTableData, setResolverTableData] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [addToStageAlert, setAddToStageAlert] = useState(true);
	const [selectNodeHierarchy, setSelectNodeHierarchy] = useState(false);
	const [addToRoutingTable, setAddToRoutingTable] = useState(true);
	const [clientUnresolvedData, setClientUnresolvedData] = useState([]);
	const [clientUnresolvedTotal, setClientUnresolvedTotal] = useState(0);
	const [clientUnresolvedPage, setClientUnresolvedPage] = useState(1);
	const [clientUnresolvedPageSize, setClientUnresolvedPageSize] = useState(20);
	const [clientUnresolvedSearch, setClientUnresolvedSearch] = useState('');
	const [clientUnresolvedJumpPage, setClientUnresolvedJumpPage] = useState('');
	const clientUnresolvedTotalPages = Math.ceil(clientUnresolvedTotal / clientUnresolvedPageSize) || 1;	
	const [nestedAlerts, setNestedAlerts] = useState({});
	const [expandedRows, setExpandedRows] = useState({});
	const [selectedNestedIds, setSelectedNestedIds] = useState({});	
	const [showAlertRoutingSummary, setShowAlertRoutingSummary] = useState(false);		
	const [alertRoutingSummaryRows, setAlertRoutingSummaryRows] = useState([]);
	const [newDomainName, setNewDomainName] = useState('');
	const [showNewSubDomainInput, setShowNewSubDomainInput] = useState(false);
	const [newSubDomainName, setNewSubDomainName] = useState('');
	const [unresolvedRoutings, setUnresolvedRoutings] = useState([]);
	const [showNewDomainInput, setShowNewDomainInput] = useState(false);
	const [newSubDomainRowIdx, setNewSubDomainRowIdx] = useState(null);
	const [showResolveSummary, setShowResolveSummary] = useState(false);
	const [routingResolverVisible, setRoutingResolverVisible] = useState(false);		
	const [summaryNewDomainInputIdx, setSummaryNewDomainInputIdx] = useState(null);
	const [summaryNewDomainName, setSummaryNewDomainName] = useState('');
	const [summaryNewSubDomainInputIdx, setSummaryNewSubDomainInputIdx] = useState(null);
	const [summaryNewSubDomainName, setSummaryNewSubDomainName] = useState('');
	const summaryCardRef = useRef(null);
	const [addToMultiAlerts, setAddToMultiAlerts] = useState(true);
	const [addToRoutingTableMultiAlert, setAddToRoutingTableMultiAlert] = useState(true);
	const [selectNodeHierarchyMultiAlert, setSelectNodeHierarchyMultiAlert] = useState(false);
	const [showNodeSelectionCardMultiAlert, setShowNodeSelectionCardMultiAlert] = useState(false);
	const [treeDataMultiAlert, setTreeDataMultiAlert] = useState(null);
	const [showFinalRoutingCard, setShowFinalRoutingCard] = useState(false);
	const [selectedDomainId, setSelectedDomainId] = useState('');
    const [tab2DomainList, setTab2DomainList] = useState([]);
	const [tab2SubDomainLists, setTab2SubDomainLists] = useState([]);
	const [showScrollToEnd, setShowScrollToEnd] = useState(true);
	const [collapsedMap, setCollapsedMap] = useState({});
	const [checkedIds, setCheckedIds] = useState([]);
	const endOfTreeRef = useRef(null);
	const [treeData, setTreeData] = useState(null);	
	const [urLoading, setUrLoading] = useState(false);
	const [urPage, setUrPage] = useState(1);
	const [urLimit, setUrLimit] = useState(20);
	const [urTotal, setUrTotal] = useState(0);
	const [urSearchInput, setUrSearchInput] = useState('');
	const [urSearchTerm, setUrSearchTerm] = useState('');
	const [urGotoPageInput, setUrGotoPageInput] = useState('');
	const [sortColumn, setSortColumn] = useState('');
	const [sortDirection, setSortDirection] = useState('asc');
	const treeDivRef = useRef(null);
	//1st tab pagination
	const urTotalPages = Math.ceil(urTotal / urLimit) || 1;
	const urPageNumbers = [];
	const urPageGroupSize = 10;
	const urCurrentGroup = Math.floor((urPage - 1) / urPageGroupSize);
	const urStartPage = urCurrentGroup * urPageGroupSize + 1;
	const urEndPage = Math.min(urStartPage + urPageGroupSize - 1, urTotalPages);
	for (let i = urStartPage; i <= urEndPage; i++) urPageNumbers.push(i);
	//2nd tab Pagination
	const pageGroupSize = 10;	
	const currentGroup = Math.floor((clientUnresolvedPage - 1) / pageGroupSize);
	const startPage = currentGroup * pageGroupSize + 1;
	const endPage = Math.min(startPage + pageGroupSize - 1, clientUnresolvedTotalPages);
	const pageNumbers = [];
	for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
		

	const headers = Object.keys(resolverTableData[0] || {})
	  .filter(
	    h =>
	      h !== '_id' &&
	      h !== 'create_date' &&
	      h !== 'mongo_id' &&
	      h !== 'domain_id' &&
	      h !== 'domain' &&
	      h !== 'subdomain' &&
	      h !== 'subdomain_id' &&
	      h !== 'subDomainName' &&
		  h !== 'ds_hash' &&
	      h !== 'domainName'
	  );
	  
	  

	const dropdownDomainList = [
	    { domainId: -1, domainName: 'Add A New Domain' },
	    ...domainList
	];
	const [selectedDomainIds, setSelectedDomainIds] = useState([]);
	const [selectedSubDomainIds, setSelectedSubDomainIds] = useState([]);

	

	useEffect(() => {
	  if (resolverTableData.length > 0) {
	    // Preselect domain and subdomain for each row
	    const domainIds = resolverTableData.map(row => row.domain_id || '');
	    const subDomainIds = resolverTableData.map(row => row.subdomain_id || '');
	    setSelectedDomainIds(domainIds);
	    setSelectedSubDomainIds(subDomainIds);

	    // For each row, if domain_id exists, load subdomains and enable subdomain dropdown
	    resolverTableData.forEach((row, idx) => {
	      if (row.domain_id) {
	        // Fetch subdomains for this domain_id
	        apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
	          method: 'POST',
	          headers: {
	            'Content-Type': 'application/json',
	            'X-Username': username,
	            'Authorization': `Bearer ${mrToken}`
	          },
	          body: JSON.stringify({ domainId: row.domain_id })
	        })
	        .then(res => res.json())
	        .then(data => {
	          setSubDomainLists(prev => ({
	            ...prev,
	            [idx]: data.data.SUBDOMAIN_LIST || []
	          }));
	          setSubDomainEnabled(prev => ({
	            ...prev,
	            [idx]: true
	          }));
	        });
	      }
	    });
	  }
	}, [resolverTableData]);

	
   //Fetch all active clients
	useEffect(() => {
	  const fetchClients = async () => {
		setLoading(true);
			await callApi(async () => {
				setIsApiLoading(true);
	        try {
	          const response = await apiFetch(`${config.API_BASE_URL}/activeclients`,
	            {headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`}},
	          );
	          if (response.ok) {
	            const data = await response.json();
	            setClients(Array.isArray(data.data.ACTIVE_CLIENTS) ? data.data.ACTIVE_CLIENTS : []);
	          }
	        } catch (err) {
	          setClients([]);
	        }finally {
	  			setLoading(false);
	  			setIsApiLoading(false);
	  		}
		  	});
	  };
	  fetchClients();
	}, []);
	
	
	useEffect(() => {
	  if (showAlertRoutingSummary && summaryCardRef.current) {
	    summaryCardRef.current.scrollIntoView({ behavior: 'smooth' });
	  }
	}, [showAlertRoutingSummary, alertRoutingSummaryRows]);
	

	useEffect(() => {
	  if (showTree && treeDivRef.current) {
	    treeDivRef.current.scrollIntoView({ behavior: 'smooth' });
	  }
	}, [showTree, treeData]);
	
	useEffect(() => {
	  fetchUnresolvedRoutings(urSearchTerm, (urPage - 1) * urLimit, urLimit);
	  // eslint-disable-next-line
	}, [ sortColumn, sortDirection,  urSearchTerm, urPage, urLimit]);

	useEffect(() => {
	  if (resolverTableData.length > 0) {
	    // Map domain/subdomain IDs for each row
	    const domainIds = resolverTableData.map(row => row.domain_id || '');
	    const subDomainIds = resolverTableData.map(row => row.subdomain_id || '');
	    setSelectedDomainIds(domainIds); // or setSelectedDomainIds({[row.mongo_id]: id, ...})
	    setSelectedSubDomainIds(subDomainIds);
	  }
	}, [resolverTableData]);
	
	const handleExpandAll = () => {
	  setShowTree(true);
	  
	  if (!treeData) return;
	  const allIds = {};
	  const collectIds = nodes => {
	    nodes.forEach(node => {
	      allIds[node.id] = false;
	      if (node.children) collectIds(node.children);
	    });
	  };
	  collectIds(treeData);
	  setCollapsedMap(allIds);
	};
	
	// Check All
	const handleCheckAll = () => {
	  if (!treeData) return;
	  const allIds = [];
	  const collectIds = nodes => {
	    nodes.forEach(node => {
	      allIds.push(node.id);
	      if (node.children) collectIds(node.children);
	    });
	  };
	  collectIds(treeData);
	  setCheckedIds(allIds);
	};
	
	//Uncheck all
	const handleUncheckAll = () => setCheckedIds([]);

	// Collapse All
	const handleCollapseAll = () => {
	  setShowTree(false);
	  if (!treeData) return;
	  const allIds = {};
	  const collectIds = nodes => {
	    nodes.forEach(node => {
	      allIds[node.id] = true;
	      if (node.children) collectIds(node.children);
	    });
	  };
	  collectIds(treeData);
	  setCollapsedMap(allIds);
	};
	
	//Select all
	const handleSelectAll = (checked) => {
	  if (checked) {
	    setSelectedIds(resolverTableData.map(row => row.mongo_id));
	  } else {
	    setSelectedIds([]);
	  }
	};
	
	const handleCheckboxChange = (mongoId) => {
	  setSelectedIds(prev =>
	    prev.includes(mongoId)
	      ? prev.filter(id => id !== mongoId)
	      : [...prev, mongoId]
	  );
	};
	

		
	const handleUrGotoPage = () => {
	  const page = Number(urGotoPageInput);
	  if (!page || page < 1 || page > urTotalPages) {
	    PopupService.getInstance().showMessage('Entered page number not valid', false);
	    return;
	  }
	  setUrPage(page);
	};

	const handleNodeHierarchyCheckbox = (e) => {
	  const checked = e.target.checked;
	  setSelectNodeHierarchy(checked);
	  setShowNodeSelectionCard(checked);
	  if (!checked) {
	    setCheckedIds([]);    // Reset selected nodes
	    setTreeData(null);    // Hide tree
	  }
	};

	// Helper to collect all node IDs
	const getAllNodeIds = (nodes) => {
	  let ids = [];
	  nodes.forEach(node => {
	    ids.push(node.id);
	    if (node.children) ids = ids.concat(getAllNodeIds(node.children));
	  });
	  return ids;
	};
	
	const handleCancelNodeSelection = () => {
	    setShowNodeSelectionCard(false);      // Hide node selection card
	    setSelectNodeHierarchy(false);        // Uncheck the checkbox
	    setCheckedIds([]);                    // Uncheck all nodes
	    setTreeData(null);   
		setShowScrollToEnd(false);                 // Reset tree data
	 };
	 
	 const initializeAlertsTab = () => {
	   setSelectedIds([]);
	   setResolverTableData([]);
	   setShowResolveSummary(false);
	   setShowNodeSelectionCard(false);
	   setTreeData(null);
	   setCheckedIds([]);
	   setSubDomainEnabled({});
	   setSubDomainLists({});
	   setShowAlertRoutingSummary(false);
	   setAlertRoutingSummaryRows([]);
	   setRoutingResolverVisible(false); // <-- Hide the details card
	 };

	
	const handleDomainChange = async (rowIdx, domainId) => {		
		const selectedDomain = domainList.find(d => String(d.domainId) === String(domainId));
		const domainName = selectedDomain ? selectedDomain.domainName : '';

		setResolverTableData(prev =>
		  prev.map((row, idx) =>
		    idx === rowIdx
		      ? { ...row, domain: domainName, subdomain: '' } // No domain_id here
		      : row
		  )
		);
	  
	   setResolverTableData(prev =>
	      prev.map((row, idx) =>
	        idx === rowIdx
	          ? { ...row, domain: domainName, domain_id: domainId, subdomain: '' }
	          : row
	      )
	    );
	  setSubDomainLists(prev => ({
	    ...prev,
	    [rowIdx]: [],
	  }));
	  // Do NOT reset all enabled states here!
	  // setSubDomainEnabled({}); <-- REMOVE THIS LINE
	  setSubDomainEnabled(prev => ({
	    ...prev,
	    [rowIdx]: true, // Only enable the current row
	  }));
	  // ...fetch subdomains as before
	  if (!mrToken) {
	    PopupService.getInstance().showMessage('Session expired. Please log in again.', false);
	    return;
	  }
	  await callApi(async () => {
	  setIsApiLoading(true);
	  try {
		  const response = await apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
		    method: 'POST',
		    headers: {'Content-Type': 'application/json','X-Username' :username, 
				'Authorization': `Bearer ${mrToken}`},
		    body: JSON.stringify({ domainId })
		  });
		  if (response.status === 401) {
		    PopupService.getInstance().showMessage('Unauthorized. Please log in again.', false);
		    return;
		  }
		  const data = await response.json();
		  setSubDomainLists(prev => ({ ...prev, [rowIdx]: data.data.SUBDOMAIN_LIST || [] }));
		  } finally {
	        setLoading(false);
	        setIsApiLoading(false);
	      }  
		 }); 
	};
	
	const handleStartRoutingResolution = () => {
		const missingDomain = resolverTableData
		    .filter(row => selectedIds.includes(row.mongo_id))
		    .some(row => !row.domain_id || String(row.domain_id).trim() === '' 
			|| row.domain_id === 'Select Domain');

		  if (missingDomain) {
		    PopupService.getInstance().showMessage('A domain must be selected to resolve this routing', false);
		    return;
		  }
	  setShowResolveSummary(true);
	  setTimeout(() => {
	    summaryRef.current?.scrollIntoView({ behavior: 'smooth' });
	  }, 0); // Wait for render
	};
		
	const handleStatusChange = (rowIdx, newStatus) => {
	  setResolverTableData(prev =>
	    prev.map((row, idx) =>
	      idx === rowIdx ? { ...row, status: newStatus } : row
	    )
	  );
	};
		
	const fetchUnresolvedRoutings = async (search, offset, limit) => {
	    setLoading(true);
	    await callApi(async () => {
	      setIsApiLoading(true);
	      try {
	        const response = await apiFetch(`${config.API_BASE_URL}/searchMissingRoutings`, {
	          method: 'POST',
	          headers: { 'Content-Type': 'application/json', 'X-Username': username, 
				'Authorization': `Bearer ${mrToken}` },
	          body: JSON.stringify({
	            search,
	            offset,
	            limit,
	            sortColumn,
	            sortDirection
	          })
	        });
			if (response.ok) {
			      const data = await response.json();
			      setUnresolvedRoutings(data.data.SEARCH_LIST || []);
			      setUrTotal(data.data.total || 0);
			    } else {
			      PopupService.getInstance().showMessage('Error loading unresolved routings', false);
			    }
	      } finally {
	        setLoading(false);
	        setIsApiLoading(false);
	      }
	    });
	  };
	  
	  const handleContinueWithRoutingResolution = async () => {
	    await callApi(async () => {
	      setIsApiLoading(true);
	      try {
	        const response = await apiFetch(`${config.API_BASE_URL}/loadHierachyTree`, {
	          method: "POST",
	          headers: {
	            "Content-Type": "application/json",
	            "X-Username": username,
	            "Authorization": `Bearer ${mrToken}`,
	          },
	          body: JSON.stringify({ clientId: selectedClientId }),
	        });
	        if (response.ok) {
	          const data = await response.json();
	          if (data.data && data.data.HIERARCHY_TREE_DATA) {
	            setTreeData(data.data.HIERARCHY_TREE_DATA);
	            setShowTree(true);
	          }
	        }
	        setShowResolveSummary(true);
	        // Scroll to top of tree_div after state update
	        setTimeout(() => {
	          treeDivRef.current?.scrollIntoView({ behavior: 'smooth' });
	        }, 0);
	      } finally {
	        setLoading(false);
	        setIsApiLoading(false);
	      }
	    });
	  };
	  
	const handleClientChange = async (e) => {
	  const clientId = e.target.value;
	  setSelectedClientId(clientId);

	  // Reset unresolved routing table
	  setClientUnresolvedData([]);
	  setClientUnresolvedTotal(0);
	  setClientUnresolvedPage(1);

	  // Reset summary table and hide it
	  setAlertRoutingSummaryRows([]);
	  setShowAlertRoutingSummary(false);

	  // Reset all checkboxes and expanded rows
	  setSelectedNestedIds({});
	  setExpandedRows({});

	  // Fetch domains for client
	  const response = await apiFetch(`${config.API_BASE_URL}/loadDomainForClient`, {
	    method: 'POST',
	    headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
	    body: JSON.stringify({ clientId })
	  });
	  const data = await response.json();
	  setTab2DomainList(data.data.DOMAIN_LIST || []);
	  setTab2SubDomainLists({});

	  // Fetch unresolved routings for client
	  await fetchClientUnresolved(clientId, 1, clientUnresolvedPageSize, '');
	};
		 


	const handleResolveRouting = async () => {
	  // Find the unresolvedRoutings row matching selectedMrNumber and selectedClientId
	  const unresolvedRow = unresolvedRoutings.find(
	    row =>
	      row.mr_number === selectedMrNumber &&
	      row.client_id === selectedClientId
	  );
	  const mssingRoutingTableMongoId = unresolvedRow ? unresolvedRow.mongo_id : undefined;

	  const selectedRows = resolverTableData
	    .filter(row => selectedIds.includes(row.mongo_id))
	    .map((row, idx) => {
	      // Find subDomainId and subDomainName from subDomainLists if subdomain is selected
	      let subDomainId = row.subdomain_id || null;
	      let subDomainName = '';
	      if (subDomainId && subDomainLists[idx]) {
	        const subDomainObj = subDomainLists[idx].find(
	          sd => String(sd.subDomainId) === String(subDomainId)
	        );
	        if (subDomainObj) {
	          subDomainName = subDomainObj.subDomainName;
	        }
	      } else {
	        subDomainName = row.subdomain || '';
	      }
	      const domainName = row.domain || '';
	      return {
	        mongoId: row.mongo_id,
	        domainId: row.domain_id,
	        domainName: domainName,
	        subDomainId: subDomainId,
	        subDomainName: subDomainName,
	        status: row.status,
	        createDate: row.create_date,
	        dynamicFields: (() => {
	          const { mongo_id, domain_id, domain, subdomain, subdomain_id, status, create_date, ...rest } = row;
	          return rest;
	        })()
	      };
	    });

	  const payload = {
	    mrNumber: selectedMrNumber,
	    clientId: selectedClientId,
	    selectedRows,
	    addToStageAlert,
	    selectNodeHierarchy,
	    addToRoutingTable,
	    selectedNodeIds: checkedIds,
	    mssingRoutingTableMongoId // Add this field to the payload
	  };
	  console.log('Routing resolution payload:', payload);

	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/confirmRoutingResolution`, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'X-Username': username,
	          'Authorization': `Bearer ${mrToken}`
	        },
	        body: JSON.stringify(payload)
	      });
	      if (response.ok) {
	        PopupService.getInstance().showMessage('Routing resolved successfully!', true);
	      } else {
	        PopupService.getInstance().showMessage('Failed to resolve routing', false);
	      }
	    } catch (err) {
	      PopupService.getInstance().showMessage('Error occurred during resolution', false);
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};
	const handleSubDomainChange = (rowIdx, subDomainId) => {
	  setResolverTableData(prev =>
	    prev.map((row, idx) =>
	      idx === rowIdx
	        ? { ...row, subdomain_id: subDomainId }
	        : row
	    )
	  );
	};
	const handleSaveNewDomain = async () => {
		if (!newDomainName || !selectedClientId) return;
		await callApi(async () => {
	 	setIsApiLoading(true);
	   	try {
		   const response = await apiFetch(`${config.API_BASE_URL}/saveNewDomain`, {
		     method: 'POST',
		     headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
		     body: JSON.stringify({ clientId: selectedClientId, domainName: newDomainName })
		   });
		   if (response.ok) {
		     setShowNewDomainInput(false);
		     setNewDomainName('');
		     PopupService.getInstance().showMessage('Domain Added Successfully', true);

		     // Reload resolverTableData and domainList
			 const reloadResponse = await apiFetch(`${config.API_BASE_URL}/findMissingRoutingsForAlert`, {
			   method: 'POST',
			   headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
			   body: JSON.stringify({ client_id: selectedClientId, batch_xl_id: selectedMrNumber ? unresolvedRoutings.find(r => r.mr_number === selectedMrNumber)?.batch_xl_id : undefined })
			 });
		     if (reloadResponse.ok) {
		       const data = await reloadResponse.json();
		       setResolverTableData(data.data.SEARCH_LIST || []);
		       setDomainList(data.data.DOMAIN_LIST || []);
		     }
		   } else {
		     PopupService.getInstance().showMessage('Failed to save domain', false);
		   }
		}catch(error){
	   	  PopupService.getInstance().showMessage('Failed to add subdomain', false);
	   	} finally {
		  setLoading(false);
  			setIsApiLoading(false);
  		}
	  });				
    };


	const handleClickMrNumber = async (e, row) => {
	  e.preventDefault();
	  setRoutingResolverVisible(true);
	  setSelectedMrNumber(row.mr_number);
	  setSelectedClientId(row.client_id);
	  setSelectedIds([]);
	  setLoading(true);

	  await callApi(async () => {
	    setIsApiLoading(true);
	    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/findMissingRoutingsForAlert`, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'X-Username': username,
	          'Authorization': `Bearer ${mrToken}`
	        },
	        body: JSON.stringify({ batch_xl_id: row.batch_xl_id, client_id: row.client_id })
	      });
	      const data = await response.json();
	      const rows = data.data.SEARCH_LIST || [];
	      setResolverTableData(rows);
	      setDomainList(data.data.DOMAIN_LIST || []);
	      setShowResolveSummary(false);
	      setSubDomainLists([]);
	      setSubDomainEnabled(Array(rows.length).fill(false));
	      setTreeData(null);
	      setShowTree(false);
	      setRoutingResolverVisible(true);

	      // Pre-select domain and subdomain if present in the first row
	      if (rows.length > 0) {
	        if (rows[0].domain_id) setSelectedDomainId(rows[0].domain_id);
	        // If you have a selectedSubDomainId state, set it here as well:
	        // if (rows[0].subdomain_id) setSelectedSubDomainId(rows[0].subdomain_id);
	      }
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};

	 
	const handleAddSubdomain = async () => {
	   const domainId = resolverTableData[newSubDomainRowIdx].domain_id;
	   const clientId = selectedClientId;
	   if (!newSubDomainName || !domainId || !clientId) return;
	   await callApi(async () => {
		setIsApiLoading(true);
	    try {
		   const response = await apiFetch(`${config.API_BASE_URL}/addSubdomain`, {
		     method: 'POST',
		     headers: { 'Content-Type': 'application/json', 
				'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
		     body: JSON.stringify({ domainId, clientId, subDomainName: newSubDomainName })
		   });

		   if (response.ok) {
		     // Reload subdomain list for this row
		     const subResp = await apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
		       method: 'POST',
		       headers: { 'Content-Type': 'application/json', 'X-Username': username, 
				'Authorization': `Bearer ${mrToken}` },
		       body: JSON.stringify({ domainId })
		     });
		     const subData = await subResp.json();
		     setSubDomainLists(prev => ({ ...prev, [newSubDomainRowIdx]: subData.data.SUBDOMAIN_LIST || [] }));
		     setShowNewSubDomainInput(false);
		     setNewSubDomainName('');
		     setNewSubDomainRowIdx(null);
		     PopupService.getInstance().showMessage('Subdomain Added Successfully', true);
		   } else {
		     PopupService.getInstance().showMessage('Failed to add subdomain', false);
		   }
		  }catch(error){
			PopupService.getInstance().showMessage('Failed to add subdomain', false);
		  }finally {
			setLoading(false);
			setIsApiLoading(false);
	  	  }
		});		
	 };
			
	 const handleClientUnresolvedPageChange = async (newPage) => {
	   setClientUnresolvedPage(newPage);
	   setExpandedRows({});           // Collapse all expanded rows
	   setSelectedNestedIds({});      // Uncheck all nested checkboxes
	   setCheckedIds([]);             // Uncheck all parent checkboxes
	   setNestedAlerts({});           // Clear nested alerts if needed
	   await fetchClientUnresolved(selectedClientId, newPage, clientUnresolvedPageSize, clientUnresolvedSearch);
	 };
	
	const fetchClientUnresolved = async (clientId, pageNo, pageSize, searchTerm) => {
	await callApi(async () => {
	  setLoading(true);
	  try {
	    const response = await apiFetch(`${config.API_BASE_URL}/findUnresolvedClientRouting`, {
	      method: 'POST',
	      headers: { 'Content-Type': 'application/json', 'X-Username': username, 
			'Authorization': `Bearer ${mrToken}` },
	      body: JSON.stringify({ clientId, pageNo, pageSize, searchTerm }),
	    });
	    if (response.ok) {
	      const data = await response.json();
	      setClientUnresolvedData(data.data.UNRESOLVED_ROUTING || []);
	      setClientUnresolvedTotal(data.data.TOTAL || 0);
	      setClientUnresolvedPage(pageNo);
	    }
	  } finally {
	    setLoading(false);
	  }
	  });	
	};
	
	const handleScrollToEndOfTree = () => {
	  if (endOfTreeRef.current) {
	    endOfTreeRef.current.scrollIntoView({ behavior: 'smooth' });
	  }
	};
	
	const handleScrollToTop = () => {
	  window.scrollTo({ top: 0, behavior: 'smooth' });
	};
	

	// Collapse all nodes in the multi-alert tree and hide Scroll To Top button
	const handleCollapseAllMuti = () => {
	  if (!treeDataMultiAlert) return;
	 setShowScrollToEnd(false); 
	  const getAllNodeIds = (nodes) => {
	    let ids = [];
	    nodes.forEach(node => {
	      ids.push(node.id);
	      if (node.children) {
	        ids = ids.concat(getAllNodeIds(node.children));
	      }
	    });
	    return ids;
	  };
	  const allIds = getAllNodeIds(Array.isArray(treeDataMultiAlert) ? treeDataMultiAlert : [treeDataMultiAlert]);
	  setCollapsedMap(prev => {
	    const newMap = { ...prev };
	    allIds.forEach(id => { newMap[id] = true; });
	    return newMap;
	  });
	};


	// Check all nodes in the multi-alert tree
	const handleCheckAllMuti = () => {
	  if (!treeDataMultiAlert) return;
	  const getAllNodeIds = (nodes) => {
	    let ids = [];
	    nodes.forEach(node => {
	      ids.push(node.id);
	      if (node.children && node.children.length > 0) {
	        ids = ids.concat(getAllNodeIds(node.children));
	      }
	    });
	    return ids;
	  };
	  const allIds = getAllNodeIds(Array.isArray(treeDataMultiAlert) ? treeDataMultiAlert : [treeDataMultiAlert]);
	  setCheckedIds(allIds);
	};

	// Uncheck all nodes in the multi-alert tree
	const handleUncheckAllMuti = () => {
	  setCheckedIds([]);
	};


	const handleCancelNodeSelectionMulti = () => {
	  setShowFinalRoutingCard(false);
	  setTreeDataMultiAlert(null);
	  setCollapsedMap({});
	  setCheckedIds([]);
	  setSelectNodeHierarchyMultiAlert(false);
	};



	const handleResolveRoutingMulti = async (e) => {
	  e && e.preventDefault && e.preventDefault();
	  
	  // Check that all parent rows have a selected domain
	   const missingDomain = alertRoutingSummaryRows.some(rowObj =>
	     !rowObj.main.domainId || rowObj.main.domainId === '' 
	   );
	   if (missingDomain) {
	     PopupService.getInstance().showMessage('Please select a domain for all rows before resolving routing.', false);
	     return;
	   }
	  try {
	    if (!alertRoutingSummaryRows || alertRoutingSummaryRows.length === 0) {
	      PopupService.getInstance().showMessage('No parent row available for routing resolution.', false);
	      return;
	    }
	    const parentRow = alertRoutingSummaryRows[0];
	    const nestedRows = parentRow.nested || [];
	    const nestedRowMap = {};
	    nestedRows.forEach(row => {
	      if (row.mongo_id && row.mr_number) {
	        nestedRowMap[row.mongo_id] = row.mr_number;
	      }
	    });

	    const main = parentRow.main || {};
	    const clientIdSel = main.client_id || null;
	    const domainIdSel = main.domain_id || null;
	    const subDomainIdSel = main.subDomainId || null;
	    const domainNameSel = main.domain || main.domainName || '';
	    const subDomainNameSel = main.subdomain || main.subDomainName || '';

	    const { nested, ...parentRowWithoutNested } = parentRow;

	    // Build payload for backend
	    const payload = {
	      parentRow: parentRowWithoutNested,
	      selectedDomainId: domainIdSel,
	      selectedSubDomainId: subDomainIdSel,
	      domainName: domainNameSel,
	      subdomainName: subDomainNameSel,
	      nestedRowMap: nestedRowMap,
	      addToAlerts: !!addToMultiAlerts,
	      addToRoutingTable: !!addToRoutingTableMultiAlert,
	      selectNodeHierarchy: !!selectNodeHierarchyMultiAlert,
	      selectedClientId: clientIdSel,
	      selectedNodeIds: checkedIds
	    };

	    console.log("Routing resolution payload:", payload);

	    // Make API call
	    const response = await apiFetch(`${config.API_BASE_URL}/resolveRoutingMultiALerts`, {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json",
	        "X-Username": username,
	        "Authorization": `Bearer ${mrToken}`
	      },
	      body: JSON.stringify(payload),
	    });

	    const result = await response.json();
	    if (response.ok) {
	      PopupService.getInstance().showMessage('Routing resolved successfully.', true);
	    } else {
	      PopupService.getInstance().showMessage('Failed to resolve routing.', false);
	    }
	  } catch (err) {
	    console.error("Error resolving routing:", err);
	    alert("An error occurred while resolving routing.");
	  }
	};
	
	function TreeNode({ node, collapsedMap, onToggle, checkedIds, onCheck, ancestorCollapsed = false, level = 0 }) {
	  const isCollapsed = collapsedMap[node.id];
	  const prefix = Array(level).fill('-');

	  return (
	    <li className="list-group-item">
	      {node.children && node.children.length > 0 && (
	        <span
	          style={{ cursor: "pointer", marginRight: 5 }}
	          className={isCollapsed ? "tree-toggle-collapsed" : "tree-toggle-expanded"}
	          onClick={() => onToggle(node.id)}
	        >
	          <i className={`fa ${isCollapsed ? "fa-plus-square" : "fa-minus-square"}`}></i>
	        </span>
	      )}
	      
	   {level > 0 && <span  style={{ marginRight: 4 }}>{'|' + Array(level).fill('-').join('')}</span>}
	      {level === 0 && <span  style={{ marginRight: 5 }}></span>}
	      <input
	        type="checkbox"
	        value={node.id}
	        checked={checkedIds.includes(node.id)}
	        onChange={() => onCheck(node.id)}
	        style={{ marginRight: 6 }}
	      />
	      <span>{node.title}</span>
	      {node.children && node.children.length > 0 && !isCollapsed && (
	        <ul className="list-group list-group-flush">
	          {node.children.map(child => (
	            <TreeNode
	              key={child.id}
	              node={child}
	              collapsedMap={collapsedMap}
	              onToggle={onToggle}
	              checkedIds={checkedIds}
	              onCheck={onCheck}
	              ancestorCollapsed={ancestorCollapsed || isCollapsed}
	              level={level + 1}
	            />
	          ))}
	        </ul>
	      )}
	    </li>
	  );
	}

	function Tree({ data, collapsedMap, setCollapsedMap, checkedIds, setCheckedIds }) {
	  const handleToggle = id => {
	    setCollapsedMap(prev => ({ ...prev, [id]: !prev[id] }));
	  };
	  const handleCheck = id => {
	    setCheckedIds(prev =>
	      prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id]
	    );
	  };
	  return (
	    <ul className="list-group list-group-flush">
	      {data.map(node => (
	        <TreeNode
	          key={node.id}
	          node={node}
	          collapsedMap={collapsedMap}
	          onToggle={handleToggle}
	          checkedIds={checkedIds}
	          onCheck={handleCheck}
	          ancestorCollapsed={false}
	          level={0}
	        />
	      ))}
	   <div ref={endOfTreeRef} />
	    </ul>
	  );
	}
	const handleNodeHierarchyCheckboxMultiAlert = (e) => {
	  setSelectNodeHierarchyMultiAlert(e.target.checked);
	};
	const handleCancelResolveRouting = () => {
	  setSelectedIds([]);
	  setSubDomainEnabled({});
	  setSubDomainLists({});
	  // Optionally reset resolverTableData to its original state if you have a backup
	  setResolverTableData(prev =>
	    prev.map(row => ({
	      ...row,
	      status: 'UNRESOLVED', // or original status if you have it
	      // Optionally reset domain/subdomain fields if you track them in state
	    }))
	  );
	};
	
				
		
	const handleSearch = () => {
	  setRoutingResolverVisible(false);
	  setUrSearchTerm(urSearchInput);
	  setUrPage(1);
	};

	const handleSort = (column) => {
	   if (sortColumn === column) {
	     setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
	   } else {
	     setSortColumn(column);
	     setSortDirection('asc');
	   }
	 };
	 
	const handleContinueResolutionMultipleAlerts = async () => {
		const missingDomain = alertRoutingSummaryRows.some(rowObj =>
		    !rowObj.main.domainId || rowObj.main.domainId === '' || rowObj.main.domainId === 'Select Domain'
		  );
		  if (missingDomain) {
		    PopupService.getInstance().showMessage('Please select a domain for all rows before resolving routing.', false);
		    return;
		  }
		  setLoading(true);
		  try {
		    const response = await apiFetch(`${config.API_BASE_URL}/loadHierachyTree`, {
		      method: "POST",
		      headers: {
		        "Content-Type": "application/json",
		        "X-Username": username,
		        "Authorization": `Bearer ${mrToken}`,
		      },
		      body: JSON.stringify({ clientId: selectedClientId }),
		    });
		    if (response.ok) {
		      const data = await response.json();
		      if (data.data && data.data.HIERARCHY_TREE_DATA) {
		        setTreeDataMultiAlert(data.data.HIERARCHY_TREE_DATA);
		        setShowFinalRoutingCard(true);
		      }
		    }
		  } catch (err) {
		    // handle error
		  } finally {
		    setLoading(false);
		  }
	};


	// Expand all nodes in the multi-alert tree
	const handleExpandAllMulti = () => {
	  if (!treeDataMultiAlert) return;
	  // Recursively collect all node IDs
	 setShowScrollToEnd(true); 
	  const getAllNodeIds = (nodes) => {
	    let ids = [];
	    nodes.forEach(node => {
	      ids.push(node.id);
	      if (node.children && node.children.length > 0) {
	        ids = ids.concat(getAllNodeIds(node.children));
	      }
	    });
	    return ids;
	  };
	  const allIds = getAllNodeIds(Array.isArray(treeDataMultiAlert) ? treeDataMultiAlert : [treeDataMultiAlert]);
	  // Set all nodes to expanded (false = not collapsed)
	  setCollapsedMap(prev => {
	    const newMap = { ...prev };
	    allIds.forEach(id => { newMap[id] = false; });
	    return newMap;
	  });
	};

	const parentHeaders = alertRoutingSummaryRows.length > 0
	  ? Object.keys(alertRoutingSummaryRows[0].main).filter(
	      k =>
	        k !== 'mongo_id' &&
	        k !== '_id' &&
	        k !== 'domain' &&
	        k !== 'domain_id' &&
	        k !== 'domainId' &&
		    k !== 'subDomainId' &&
		    k !== 'client_id' &&
			k !== 'ds_hash' &&
	        k !== 'subdomain'
	    )
	  : [];

	// Filter out domain/subdomain fields for nested headers
	const nestedHeaders = alertRoutingSummaryRows.length > 0 && alertRoutingSummaryRows[0].nested.length > 0
	  ? Object.keys(alertRoutingSummaryRows[0].nested[0]).filter(
	      k =>
	        k !== 'mongo_id' &&
	        k !== '_id' &&
	        k !== 'domain' &&
	        k !== 'domain_id' &&
	        k !== 'domainId' &&
		    k !== 'subDomainId' &&
			k !== 'ds_hash' &&
	        k !== 'subdomain'
	    )
	  : [];


	  // Add this in your component, replacing the previous handleDeleteNestedRow
	  const handleDeleteNestedRow = (parentIdx, nestedMongoId) => {
	    setNestedAlerts(prev => ({
	      ...prev,
	      [parentIdx]: Array.isArray(prev[parentIdx])
	        ? prev[parentIdx].filter(row => row.mongo_id !== nestedMongoId)
	        : []
	    }));
	    setSelectedNestedIds(prev => ({
	      ...prev,
	      [parentIdx]: Array.isArray(prev[parentIdx])
	        ? prev[parentIdx].filter(id => id !== nestedMongoId)
	        : []
	    }));
	    setAlertRoutingSummaryRows(prev =>
	      prev.map((rowObj, idx) =>
	        idx === parentIdx
	          ? {
	              ...rowObj,
	              nested: rowObj.nested.filter(nested => nested.mongo_id !== nestedMongoId)
	            }
	          : rowObj
	      )
	    );
	  };

	const loadSubdomainForAlertwise = async (domainId, rowIdx) => {
	setLoading(true);
	await callApi(async () => {
		try {
	     const response = await apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
	       method: 'POST',
	       headers: {
	         'Content-Type': 'application/json',
	         'X-Username': username,
	         'Authorization': `Bearer ${mrToken}`
	       },
	       body: JSON.stringify({ domainId })
	     });
	     const data = await response.json();
	     setTab2SubDomainLists(prev => ({
	       ...prev,
	       [rowIdx]: data.data.SUBDOMAIN_LIST || []
	     }));
		 }finally {
		       setLoading(false);
		       setIsApiLoading(false);
		     }
		   });	 
	  };

	  const handleClientUnresolvedSearch = () => {
	    fetchClientUnresolved(selectedClientId, 1, clientUnresolvedPageSize, clientUnresolvedSearch);
	  };

	  const handleClientUnresolvedJumpPage = () => {
		
		 setExpandedRows({});           // Collapse all expanded rows
		 setSelectedNestedIds({});      // Uncheck all nested checkboxes
		 setCheckedIds([]);             // Uncheck all parent checkboxes
		 setNestedAlerts({}); 
	    const page = Number(clientUnresolvedJumpPage);
	    const totalPages = Math.ceil(clientUnresolvedTotal / clientUnresolvedPageSize);
	    if (!page || page < 1 || page > totalPages) {
	      PopupService.getInstance().showMessage('Entered page number not valid', false);
	      return;
	    }
		setClientUnresolvedPage(page);
	    fetchClientUnresolved(selectedClientId, page, clientUnresolvedPageSize, clientUnresolvedSearch);
	  };
	  
	  const clientUnresolvedHeaders = [
	  	  'No.',
	  	  'actions',
	  	  ...(clientUnresolvedData.length > 0
	  	    ? Object.keys(clientUnresolvedData[0]).filter(h => h !== 'mongo_id' 
				&& h !== '_id' && h !== 'ds_hash' && h !== 'domain_id' && h !== 'domain_name'
			    && h !== 'subdomain_id' && h !== 'subdomain_name')
	  	    : [])
	  	];
		
		
		const highlightText = (text, searchTerm) => {
		  if (!searchTerm) return text;
		  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
		  return String(text).split(regex).map((part, i) =>
		    regex.test(part) ? <span className='bg-info' key={i}>{part}</span> : part
		  );
		};		

		const handleExpandRow = async (mongo_id, client_id, rowIdx) => {
		  // If already expanded, collapse it and reset nested selection for this row
		  if (expandedRows[rowIdx]) {
		    setExpandedRows({});
		    setSelectedNestedIds({});
		    setCheckedIds([]);
		    setNestedAlerts({});
		    setShowAlertRoutingSummary(false);
		    setAlertRoutingSummaryRows([]);
		    return;
		  }
		  // Collapse all, reset all checkboxes and nested alerts
		  setExpandedRows({});
		  setSelectedNestedIds({});
		  setCheckedIds([]);
		  setNestedAlerts({});
		  setShowAlertRoutingSummary(false);
		  setAlertRoutingSummaryRows([]);
		  await callApi(async () => {
		    setIsApiLoading(true);
		    try {
		      const res = await apiFetch(`${config.API_BASE_URL}/fetchAlertsForMissingRouting`, {
		        method: 'POST',
		        headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
		        body: JSON.stringify({ mongo_id, client_id })
		      });
		      const data = await res.json();
		      // Only expand the clicked row and set its nested alerts
		      setNestedAlerts({ [rowIdx]: data.data.alerts || [] });
		      setExpandedRows({ [rowIdx]: true });
		    } finally {
		      setLoading(false);
		      setIsApiLoading(false);
		    }
		  });
		};



		async function handleStartRoutingResolutionAlertWise() {
		  setShowAlertRoutingSummary(true);
		  if (summaryCardRef.current) {
		    summaryCardRef.current.scrollIntoView({ behavior: 'smooth' });
		  }

		  // Collect checked main rows and nested rows
		  const summaryRows = clientUnresolvedData
		    .map((row, idx) => {
		      const nestedChecked = (selectedNestedIds[idx] || []).map(nid =>
		        (nestedAlerts[idx] || []).find(alert => alert.mongo_id === nid)
		      ).filter(Boolean);
		      if (nestedChecked.length > 0) {
		        const domainId = row.domain_id || row.domainId;
		        const subDomainId = row.subdomain_id || row.subDomainId || '';
		        const selectedDomain = domainId
		          ? tab2DomainList.find(d => String(d.domainId) === String(domainId))
		          : null;
		        return {
		          main: {
		            ...row,
		            domain_id: domainId || '',
		            domainId: domainId || '',
		            domain: selectedDomain?.domainName || '',
		            domainName: selectedDomain?.domainName || '',
		            subDomainId: subDomainId,
		            subdomain: ''
		          },
		          nested: nestedChecked.map(nested => ({
		            ...nested,
		            domain_id: '',
		            domainId: '',
		            domain: '',
		            subDomainId: '',
		            subdomain: ''
		          }))
		        };
		      }
		      return null;
		    })
		    .filter(Boolean);

		  setAlertRoutingSummaryRows(summaryRows);

		  // Prefetch subdomains for each summary row with subDomainId
		  const newSubDomainLists = {};
		  await Promise.all(summaryRows.map(async (rowObj, idx) => {
		    const domainId = rowObj.main.domainId;
		    const subDomainId = rowObj.main.subDomainId;
		    if (domainId && subDomainId) {
		      const response = await apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
		        method: 'POST',
		        headers: {
		          'Content-Type': 'application/json',
		          'X-Username': username,
		          'Authorization': `Bearer ${mrToken}`
		        },
		        body: JSON.stringify({ domainId })
		      });
		      const data = await response.json();
		      newSubDomainLists[idx] = data.data.SUBDOMAIN_LIST || [];
		    } else {
		      newSubDomainLists[idx] = [];
		    }
		  }));
		  setTab2SubDomainLists(newSubDomainLists);

		  setSummaryNewDomainInputIdx(null);
		  setSummaryNewDomainName('');
		  setSummaryNewSubDomainInputIdx(null);
		  setSummaryNewSubDomainName('');
		  setShowAlertRoutingSummary(true);
		}


		// Add this function in ResolveRouting.js
		const fetchAlertsForMissingRouting = async (mongo_id, client_id) => {
		  
			return await apiFetch(`${config.API_BASE_URL}/fetchAlertsForMissingRouting`, {
		    method: 'POST',
		    headers: {
		      'Content-Type': 'application/json',
		      'X-Username': username,
		      'Authorization': `Bearer ${mrToken}`,
		    },
		    body: JSON.stringify({ mongo_id, client_id }),
		  }).then(res => res.json());
		};





		// In ResolveRouting.js
		const handleDiscardForCleanup = async () => {
		  if (!Object.values(selectedNestedIds).some(arr => arr && arr.length > 0)) return;
		  const mongoIds = Object.values(selectedNestedIds).flat();
		  await callApi(async () => {
		    setIsApiLoading(true);
		    try {
		      // Call discard API
		      await apiFetch(`${config.API_BASE_URL}/discardForCleanup`, {
		        method: 'POST',
				headers: {
						      'Content-Type': 'application/json',
						      'X-Username': username,
						      'Authorization': `Bearer ${mrToken}`,
						    },
		        body: JSON.stringify({ mongo_ids: mongoIds }),
		      });

		      // Refresh nested alerts for expanded rows

			  await Promise.all(
			    Object.keys(expandedRows).map(async parentIdxStr => {
			      const parentIdx = Number(parentIdxStr);
			      const parentRow = clientUnresolvedData[parentIdx];
			      if (parentRow) {
			        const data = await fetchAlertsForMissingRouting(parentRow.mongo_id, parentRow.client_id);
			        setNestedAlerts(prev => ({
			          ...prev,
			          [parentIdx]: (data.data && data.data.alerts) ? data.data.alerts : [],
			        }));
			      }
			    })
			  );


		      // Optionally clear selected nested IDs after discard
		      setSelectedNestedIds({});
		    } finally {
		      setIsApiLoading(false);
		    }
		  });
		};

  return (
    <>
      <Header />
      <div className="container-fluid text-secondary">
        <br />
        <br />
        <br />
		<div className='card'>
			<div className='card-header'>Resolve Routings For Clients</div>
			<div className='card-body custom-card-bg'>
	          <div className='card'>
	          <div className="card-body">
			  {/*start tab*/}
			  
			  <ul className="nav nav-tabs " role="tablist">
				<li className="nav-item" role="presentation">
					<button
						className={`nav-link ${activeTab === 'alerts' ? 'active' : 'text-secondary'}`}
						onClick={() => setActiveTab('alerts')}
						type="button"
						role="tab"
					>
						Unresolved Routings - Alerts
					</button>
				</li>
				<li className="nav-item" role="presentation">
				<button
				  className={`nav-link ${activeTab === 'second' ? 'active' : 'text-secondary'}`}
				  onClick={() => {
				    setActiveTab('second');
				    initializeAlertsTab(); // <-- call the initializer
				  }}
				  type="button"
				  role="tab"
				>
				  Unresolved Routings - Clients
				</button>
				</li>
			  </ul>	
{/* 1st tab unresolved routing - Alerts starts here*/}	
{activeTab === 'alerts' && (
  <div className="tab-content p-3 border-0">
   {/* Content for Unresolved Routings - Alerts */}				 
   {showNodeSelectionCard && treeData && (
	<div id="tree_div" ref={treeDivRef} className="card mb-3">
	      <div className="card-header">Select Node(s) for Routing Resolution {selectedMrNumber ? ` - ${selectedMrNumber}` : ''} {selectedClientId ? ` - ${selectedClientId}` : ''}</div>
	      <div className="card-body">
		<div className="col-md-8">
           <div>
             <div className="mb-2">
               <button className="btn btn-sm btn-outline-primary me-2" onClick={handleExpandAll}>Expand All</button>
               <button className="btn btn-sm btn-outline-primary me-2" onClick={handleCollapseAll}>Collapse All</button>
               <button className="btn btn-sm btn-outline-success me-2" onClick={handleCheckAll}>Check All</button>
               <button className="btn btn-sm btn-outline-danger me-2" onClick={handleUncheckAll}>Uncheck All</button>
			   {showScrollToEnd && (
	              <button className="btn btn-sm btn-outline-info" onClick={handleScrollToEndOfTree}>
	                Scroll To End Of Tree
	              </button>
	            )}
			   </div>
             <Tree
               data={treeData}
               collapsedMap={collapsedMap}
               setCollapsedMap={setCollapsedMap}
               checkedIds={checkedIds}
               setCheckedIds={setCheckedIds}
             />
           </div>
		</div>

		<>
		 <br/>
		  <button
		    className="btn btn-danger btn-sm"
		    onClick={handleResolveRouting}
		    disabled={selectedIds.length === 0}
		  >
		    Resolve Routing
		  </button>
		  <button
		    className="btn btn-secondary btn-sm ms-2"
		    onClick={handleCancelNodeSelection}
		  >
		    Cancel
		  </button>
		  {showTree && (
		    <button
		      className="btn btn-info btn-sm ms-2"
		      onClick={handleScrollToTop}
		    >
		      Scroll to Top
		    </button>
		  )}
		</>

	</div>
   </div>		   
   )}
 
{showResolveSummary && (
  <div className="card mb-3" ref={summaryRef}>
    <div className="card-header">Resolve Routing Summary- {selectedMrNumber ? ` - ${selectedMrNumber}` : ''} {selectedClientId ? ` - ${selectedClientId}` : ''}</div>
    <div className="card-body">
      <ul>
        {resolverTableData
          .filter(row => selectedIds.includes(row.mongo_id))
          .map(row => {
            const rowNumber = resolverTableData.findIndex(r => r.mongo_id === row.mongo_id) + 1;
            return (
              <li key={row.mongo_id}>
                Row {rowNumber}: Domain Name:&nbsp;<span class="badge bg-info">{row.domain}</span> /
                &nbsp;Sub Domain Name:&nbsp;<span class="badge bg-primary">{row.subdomain}</span> &mdash; 
                &nbsp;Status: &nbsp;
			  <span className={
			    row.status === 'UNRESOLVED' ? 'badge bg-warning' :
			    row.status === 'RESOLVED' ? 'badge bg-success' :
			    'badge bg-secondary'
			  }>
			    {row.status}
			  </span>

              </li>
            );
          })}
      </ul>
	<div className="mb-2">
	  <label>
	    <input
	      type="checkbox"
	      checked={addToStageAlert}
	      onChange={e => setAddToStageAlert(e.target.checked)}
	    />{' '}
	    Add selected domain/sub domains to Stage Alert
	  </label>						  
	  <br />
	  <label>
	    <input
	      type="checkbox"
	      checked={addToRoutingTable}
	      onChange={e => setAddToRoutingTable(e.target.checked)}
	    />{' '}
	    Add records in the routing table
	  </label>
	  <br />
	  <label>
	  <input
	    type="checkbox"
	    checked={selectNodeHierarchy}
	    onChange={handleNodeHierarchyCheckbox}
	  />{' '}
	    Select Node(s) from Node Hierarchy And add these Domain/Sub Domain to them
	  </label>
	</div>
	{selectNodeHierarchy && (
		  <button
		    className="btn btn-sm btn-warning"
		    onClick={handleContinueWithRoutingResolution}
		  >
		    Continue With Routing Resoution
		  </button>
		)}
		{!selectNodeHierarchy && (
		  <button
		    className="btn btn-sm btn-danger ms-2"
		    onClick={handleResolveRouting}
		    disabled={selectedIds.length === 0}
		  >
		    Resolve Routing
		  </button>
		)}
      </div>
    </div>
  )}
  
  {routingResolverVisible && (
    <div className="card mt-3" id="routing_resolver">
	<div className="card-header">
	  Missing Routing Details{selectedMrNumber ? ` - ${selectedMrNumber}` : ''} {selectedClientId ? ` - ${selectedClientId}` : ''}
	</div>
      <div className="card-body">
	  <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
	  

	  {showNewDomainInput && (
	    <div className="mb-3 d-flex align-items-center">
	      <input
	        type="text"
	        className="form-control me-2"
	        placeholder="Enter new domain name"
	        value={newDomainName}
	        onChange={e => setNewDomainName(e.target.value)}
	        style={{ maxWidth: 300 }}
	      />
		  <button
		    className="btn btn-success me-2"
		    onClick={handleSaveNewDomain}
			title="Save new domain."
		  >
		    <i className='fa fa-save'></i>
		    
		  </button>
	      <button
	        className="btn btn-secondary"
	        onClick={() => {
	          setShowNewDomainInput(false);
	          setNewDomainName('');
	        }}
	      >
		    <i className='fa fa-times'></i>
	      </button>
	    </div>
	  )}
	  {showNewSubDomainInput && (
		<div className="mb-3 d-flex align-items-center">
		<span className="me-3">
			Add New Sub Domain for Domain - <span className='badge bg-primary'>{
		  (() => {
		    const domainId = resolverTableData[newSubDomainRowIdx]?.domain_id;
		    const domainObj = domainList.find(d => String(d.domainId) === String(domainId));
		    const domainName = domainObj ? domainObj.domainName : '';
		    const subDomainName = resolverTableData[newSubDomainRowIdx]?.subdomain || '';
		    return `${domainName}${subDomainName ? ' - ' + subDomainName : ''}`;
		  })()
		}
		</span>
		</span>
		  <input
		     type="text"
		     placeholder="Enter new subdomain name"
		     className="form-control"
		     value={newSubDomainName}
		     onChange={e => setNewSubDomainName(e.target.value)}
		     style={{ maxWidth: 300 }}
		   />

		   <button
		     className="btn btn-success me-2"
		     onClick={handleAddSubdomain}
			 title="Save New Subdomain."
		   >
		     <i className='fa fa-save'></i>
		   </button>

	      <button
	        className="btn btn-secondary"
	        onClick={() => {
	          setShowNewSubDomainInput(false);
	          setNewSubDomainName('');
	          setNewSubDomainRowIdx(null);
	        }}
	      >
		    <i className='fa fa-times'></i>
	        
	      </button>
	    </div>
	  )}
	  {resolverTableData.length > 0 && (						
		<table className="table table-responsive table-bordered table-striped">
		  <thead>
		    <tr>
			<th>No.</th>
			<th>
		      <input
		        type="checkbox"
		        checked={resolverTableData.length > 0 && selectedIds.length === resolverTableData.length}
		        onChange={e => handleSelectAll(e.target.checked)}
		        indeterminate={selectedIds.length > 0 && selectedIds.length < resolverTableData.length ? "indeterminate" : undefined}
		      />
		    </th>
			<th className="fixed-domain-col">Select Domain</th>
			<th className="fixed-subdomain-col">Select Sub Domain</th>
		      {headers.map((header, idx) => (
		        <th key={idx}>{header}</th>
		      ))}
		    </tr>
		  </thead>
		  <tbody>
		    {resolverTableData.map((row, idx) => (
		      <tr key={idx}  style={{ minWidth: 60 }} className={row.status === 'UNRESOLVED' ? 'table-warning' : row.status === 'RESOLVED' ? 'table-success' : ''}>
		        <td>{idx + 1}</td>
				<td>
				       <input
				         type="checkbox"
				         value={row.mongo_id}
				         checked={selectedIds.includes(row.mongo_id)}
				         onChange={() => handleCheckboxChange(row.mongo_id)}
				       />
				     </td>
				{/* Dropdown for domain selection */}
		        <td>

				<select
				  id={`domain-select-${idx}`}
				  className="form-select"
				  value={row.domain_id || ''} // Pre-select based on row's domain_id
				  onChange={e => {
				    if (e.target.value === '-1') {
				      setShowNewDomainInput(true);
				    } else {
				      setShowNewDomainInput(false);
				      handleDomainChange(idx, e.target.value);
				    }
				  }}
				>
				  <option value="">Select Domain</option>
				  {dropdownDomainList.map(domain => (
				    <option key={domain.domainId} value={domain.domainId}>
				      {domain.domainName}
				    </option>
				  ))}
				</select>

		        </td>
				<td>
				<td className='fixed-subdomain-col'>
				<select
				  value={row.subdomain_id || ''}
				  className="form-select"
				  disabled={!subDomainEnabled[idx]}
				  onChange={e => handleSubDomainChange(idx, e.target.value)}
				>
				  <option value="">Select Subdomain</option>
				  {(subDomainLists[idx] || []).map(sub =>
				    <option key={sub.subDomainId} value={sub.subDomainId}>{sub.subDomainName}</option>
				  )}
				</select>
				</td>
			  </td>
			 {headers.map((key, i) => (
			   <td key={i}>
			     {key === 'status' ? (

					<select
					  className="form-select"
					  value={row.status || ''}
					  style={{ minWidth: '160px' }}
					  onChange={e => handleStatusChange(idx, e.target.value)}
					>
					  <option value="UNRESOLVED">UNRESOLVED</option>
					  <option value="RESOLVED">RESOLVED</option>
					</select>

			     ) : key === 'create_date' && row[key]
			       ? format(new Date(row[key]), 'MM/dd/yyyy')
			       : Array.isArray(row[key])
			         ? JSON.stringify(row[key])
			         : typeof row[key] === 'object' && row[key] !== null
			           ? JSON.stringify(row[key])
			           : row[key]}
			   </td>
			 ))}						        
		    </tr>
		   ))}
		 </tbody>
		</table>
	  )}
	  {/* ...existing table code... */}
	      <div className="d-flex justify-content-center mt-3">
		  <button
		    className="btn btn-info btn-sm text-light"
		    onClick={handleStartRoutingResolution}
		    disabled={selectedIds.length === 0}
		  >
		    Start Routing Resolution
		  </button>

			&nbsp;
			<button
			    className="btn btn-secondary btn-sm"
			    onClick={handleCancelResolveRouting}
			  >
			    Cancel
			  </button>
	      </div>
	   
		</div>
      </div>
    </div>
	
  )}					  
  <div className="card mt-3">
    <div className="card-header">Unresolved Routings - Alerts</div>
    <div className="card-body">
      <div className="d-flex justify-content-between mb-2">
        <div>
		<input
		  className="form-control d-inline-block"
		  style={{ width: 200 }}
		  placeholder="Search Unresolved"
		  value={urSearchInput}
		  onChange={e => setUrSearchInput(e.target.value)}
		  onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
		/>						
		<button className="btn btn-secondary ms-2" onClick={handleSearch}>
		  Search
		</button>
          <button className="btn btn-secondary ms-2" onClick={() => { setUrSearchInput(''); setUrSearchTerm(''); setUrPage(1); }}>
            Clear
          </button>
        </div>
        <div>
          <label className="me-2">Rows per page:</label>
          <select value={urLimit} onChange={e => { setUrLimit(Number(e.target.value)); setUrPage(1); }} className="form-select d-inline-block" style={{ width: 'auto' }}>
            <option value={20}>20</option>
            <option value={40}>40</option>
            <option value={60}>60</option>
          </select>
        </div>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
		    <th>No.</th>
            <th onClick={() => handleSort('mr_number')} style={{ cursor: 'pointer' }}>
	           MR Number&nbsp;
	           {sortColumn === 'mr_number' ? (
	             sortDirection === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
	           ) : <FontAwesomeIcon icon={faSort} />}
	         </th>
			 <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
	           Sttaus&nbsp;
	           {sortColumn === 'status' ? (
	             sortDirection === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
	           ) : <FontAwesomeIcon icon={faSort} />}
	         </th>
			 <th onClick={() => handleSort('client_id')} style={{ cursor: 'pointer' }}>
			    Client ID&nbsp;
			    {sortColumn === 'client_id' ? (
			      sortDirection === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
			    ) : <FontAwesomeIcon icon={faSort} />}
			  </th>							
			  <th onClick={() => handleSort('create_date')} style={{ cursor: 'pointer' }}>
			     Create Date&nbsp;
			     {sortColumn === 'create_date' ? (
			       sortDirection === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />
			     ) : <FontAwesomeIcon icon={faSort} />}
			   </th>				           
            <th>Missing Count</th>
            <th>Resolved Count</th>
          </tr>
        </thead>
        <tbody>
          {urLoading ? (
            <tr><td colSpan={6} className="text-center">Loading...</td></tr>
          ) : unresolvedRoutings.length === 0 ? (
            <tr><td colSpan={6} className="text-center">No data</td></tr>
          ) : (
            unresolvedRoutings.map((row, idx) => (
              <tr key={idx}>
			    <td>{(urPage - 1) * urLimit + idx + 1}</td>
                <td>
				<a
				  href="#"
				  onClick={e => handleClickMrNumber(e, row)}
				>
				  {row.mr_number}
				</a>
				</td>

				<td>
				  <span className={
				    row.status === 'UNRESOLVED' ? 'text-danger' :
				    row.status === 'RESOLVED' ? 'text-success' :
				    row.status === 'PARTIALLY_RESOLVED' ? 'text-warning' :
				    'text-secondary'
				  }>
				    {row.status}
				  </span>
				</td>

                <td>{row.client_id}</td>
				<td>
				  {row.create_date
				    ? format(new Date(row.create_date), 'MM/dd/yyyy @ HH:mm a')
				    : ''}
				</td>

				<td><span className="text-danger">{row.missing_count}</span></td>
				<td>
				  {row.resolved_count === 0
				    ? <span className="text-secondary">-</span>
				    : <span className="text-success">{row.resolved_count}</span>
				  }
				</td>

              </tr>
            ))
          )}
        </tbody>
      </table>
      <nav>
        <ul className="pagination mb-0">
          <li className={`page-item${urPage === 1 ? ' disabled' : ''}`}>
            <button className="page-link text-secondary" onClick={() => { setUrPage(1); setUrGotoPageInput(''); }} disabled={urPage === 1}>&laquo;</button>
          </li>
          <li className={`page-item${urPage === 1 ? ' disabled' : ''}`}>
            <button className="page-link text-secondary" onClick={() => { setUrPage(urPage - 1); setUrGotoPageInput(''); }} disabled={urPage === 1}>Previous</button>
          </li>
          {urPageNumbers.map(page => (
            <li key={page} className={`page-item${urPage === page ? ' active' : ''}`}>
              <button className={`page-link ${urPage === page ? 'text-light' : 'text-secondary'}`} onClick={() => { setUrPage(page); setUrGotoPageInput(''); }} >{page}</button>
            </li>
          ))}
          <li className={`page-item${urPage === urTotalPages ? ' disabled' : ''}`}>
            <button className="page-link text-secondary" onClick={() => { setUrPage(urPage + 1); setUrGotoPageInput(''); }} disabled={urPage === urTotalPages}>Next</button>
          </li>
          <li className={`page-item${urPage === urTotalPages ? ' disabled' : ''}`}>
            <button className="page-link text-secondary" onClick={() => { setUrPage(urTotalPages); setUrGotoPageInput(''); }} disabled={urPage === urTotalPages}>&raquo;</button>
          </li>
          <li>
            <div className="d-flex align-items-center ms-2">
              <input
                type="number"
                min="1"
                max={urTotalPages}
                value={urGotoPageInput}
                onChange={e => setUrGotoPageInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleUrGotoPage(); }}
                className="form-control"
                style={{ width: 80, marginRight: 4 }}
                placeholder="Page #"
                aria-label="Go to page"
              />
              <button className="btn btn-secondary btn-sm" onClick={handleUrGotoPage} type="button">Go</button>
            </div>
          </li>
        </ul>
        <span className="ms-3">Page {urPage} of {urTotalPages} - {urTotal} Records</span>
      </nav>
    </div>
  </div>				  
  </div>
)}

{/* 1st tab unresolved routing - Alerts ends here*/}		  						
 {/* 2nd tab unresolved routing - clients starts here*/}
			  {activeTab === 'second' && (
			    <div className="tab-content p-3 border-0">			     				 
		          <div className='row'>
	                <div className="form-group col-md-3">
	                     <label htmlFor="client_select" className="text-info fw-bold">Select Client</label>                                                     
	                      <select
	                        id="client_select"
	                        className="form-select"
	                        value={selectedClientId}
	                        onChange={handleClientChange}
	                      >
	                       <option value="">Select Client</option>
	                        {clients.map((client, idx) => (
	                          <option key={idx} value={client.clientId || client.id}>
	                            {client.clientName || client.name}
	                          </option>
	                        ))}
	                     </select> 
		             </div>
			      </div>
				  <br/>
				  {showFinalRoutingCard && (
				    <div className="card mb-3">
				      <div className="card-header">
				        Routing Resolution - Final
				      </div>
				      <div id="tree_div" className="card-body">
				        {/* Render your tree with checkboxes here using treeDataMultiAlert */}
				        {/* Example: */}

						{treeDataMultiAlert && (
							<>
							<div className="mb-2">
				               <button className="btn btn-sm btn-outline-primary me-2" onClick={handleExpandAllMulti}>Expand All</button>
				               <button className="btn btn-sm btn-outline-primary me-2" onClick={handleCollapseAllMuti}>Collapse All</button>
				               <button className="btn btn-sm btn-outline-success me-2" onClick={handleCheckAllMuti}>Check All</button>
				               <button className="btn btn-sm btn-outline-danger me-2" onClick={handleUncheckAllMuti}>Uncheck All</button>
							   {showScrollToEnd && (
					              <button className="btn btn-sm btn-outline-info" onClick={handleScrollToEndOfTree}>
					                Scroll To End Of Tree
					              </button>
					            )}
							   </div>
						  <Tree
						    data={treeDataMultiAlert}
						    collapsedMap={collapsedMap}
						    setCollapsedMap={setCollapsedMap}
						    checkedIds={checkedIds}
						    setCheckedIds={setCheckedIds}
						  />
						 
						 <br/>
						 <button
 						    className="btn btn-danger btn-sm"
							onClick={handleResolveRoutingMulti}
 						    disabled={checkedIds.length === 0}
 						  >
 						    Resolve Routing - Multiple Alerts
 						  </button>
 						  <button
 						    className="btn btn-secondary btn-sm ms-2"
 						    onClick={handleCancelNodeSelectionMulti}
 						  >
 						    Cancel
 						  </button>
						  
					    <button
					      className="btn btn-info btn-sm ms-2"
					      onClick={handleScrollToTop}
					    >
					      Scroll to Top
					    </button>
						</>
					  )}
				      </div>
				      <div id="resolver_table_alertwise" />
				    </div>
				  )}
				  {showAlertRoutingSummary && (
					
				  <div ref={summaryCardRef} className='card' id="alert_routing_resolution_summary" >
				    <div className='card-header'>Routing Resolution Summary - Alert Wise</div>

					<div  className='card-body' style={{ display: showAlertRoutingSummary ? 'block' : 'none' }}>
					<div id="add_sub_domain_alerts">

					{summaryNewSubDomainInputIdx !== null && (
						<div className="d-flex align-items-center mb-2">
					  Creating a new subdomain for - &nbsp;
					    <span className='badge bg-info'>
  						  {selectedDomainName}
  						</span>&nbsp;
					    <input
					      type="text"
					      className="form-control"
					      placeholder="Enter New Subdomain Name"
					      value={summaryNewSubDomainName}
					      onChange={e => setSummaryNewSubDomainName(e.target.value)}
					      style={{ maxWidth: 250 }}
					    />
					    <button
					      className="btn btn-success ms-2"
						  title="Save subdomain."
					      onClick={async () => {
					        // Get the correct domainId for the selected summary row
					        const domainId = alertRoutingSummaryRows[summaryNewSubDomainInputIdx]?.main?.domain_id
					          || alertRoutingSummaryRows[summaryNewSubDomainInputIdx]?.main?.domainId;
					        const clientId = selectedClientId;
					        if (!summaryNewSubDomainName || !domainId || !clientId) return;
					        await callApi(async () => {
					          setIsApiLoading(true);
					          try {
					            const response = await apiFetch(`${config.API_BASE_URL}/addSubdomain`, {
					              method: 'POST',
					              headers: {
					                'Content-Type': 'application/json',
					                'X-Username': username,
					                'Authorization': `Bearer ${mrToken}`
					              },
					              body: JSON.stringify({
					                domainId,
					                clientId,
					                subDomainName: summaryNewSubDomainName
					              })
					            });
					            if (response.ok) {
					              // Reload subdomain list for this row
					              const subResp = await apiFetch(`${config.API_BASE_URL}/loadSubdomains`, {
					                method: 'POST',
					                headers: {
					                  'Content-Type': 'application/json',
					                  'X-Username': username,
					                  'Authorization': `Bearer ${mrToken}`
					                },
					                body: JSON.stringify({ domainId })
					              });
					              const subData = await subResp.json();
					              setTab2SubDomainLists(prev => ({
					                ...prev,
					                [summaryNewSubDomainInputIdx]: subData.data.SUBDOMAIN_LIST || []
					              }));
					              setSummaryNewSubDomainInputIdx(null);
					              setSummaryNewSubDomainName('');
					              PopupService.getInstance().showMessage('Subdomain Added Successfully', true);
					            } else {
					              PopupService.getInstance().showMessage('Failed to add subdomain', false);
					            }
					          } catch (error) {
					            PopupService.getInstance().showMessage('Failed to add subdomain', false);
					          } finally {
					            setIsApiLoading(false);
					          }
					        });
					      }}
					    >
					      <i className='fa fa-save'></i>
					    </button>
					    <button
					      className="btn btn-secondary ms-2"
					      onClick={() => {
					        setSummaryNewSubDomainInputIdx(null);
					        setSummaryNewSubDomainName('');
					      }}
					    >
					      <i className='fa fa-times'></i>
					    </button>
						
					  </div>
					  
					)}
                     
					</div>
					
					<div id="add_domain_alerts" >
					  {summaryNewDomainInputIdx !== null && (
					    <div className="d-flex align-items-center mb-2">
					      <input
					        type="text"
					        className="form-control"
					        placeholder="Enter new domain name"
					        value={summaryNewDomainName}
					        onChange={e => setSummaryNewDomainName(e.target.value)}
					        style={{ maxWidth: 250 }}
					      />
					      <button
					        className="btn btn-success ms-2"
							title="Save new domain."
					        onClick={async () => {
					          if (!summaryNewDomainName) return;
					          await callApi(async () => {
					            setIsApiLoading(true);
					            try {
					              const response = await apiFetch(`${config.API_BASE_URL}/saveNewDomain`, {
					                method: 'POST',
					                headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					                body: JSON.stringify({ clientId: selectedClientId, domainName: summaryNewDomainName })
					              });
					              if (response.ok) {
					                PopupService.getInstance().showMessage('Domain Added Successfully', true);
					                // Reload domain list
					                const reload = await apiFetch(`${config.API_BASE_URL}/loadDomainForClient`, {
					                  method: 'POST',
					                  headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					                  body: JSON.stringify({ clientId: selectedClientId })
					                });
					                const data = await reload.json();
					                setTab2DomainList(data.data.DOMAIN_LIST || []);
					                setSummaryNewDomainInputIdx(null);
					                setSummaryNewDomainName('');
					              } else {
					                PopupService.getInstance().showMessage('Failed to add domain', false);
					              }
					            } finally {
					              setIsApiLoading(false);
					            }
					          });
					        }}
					      >
					        <i className='fa fa-save'></i>
					      </button>
					      <button
					        className="btn btn-secondary ms-2"
					        onClick={() => {
					          setSummaryNewDomainInputIdx(null);
					          setSummaryNewDomainName('');
					        }}
					      >
					        <i className='fa fa-times'></i>
					      </button>
					    </div>
					  )}
					</div>

					{alertRoutingSummaryRows.length === 0 ? (
					  <div>No alerts selected.</div>
					) : (
						
                       <>
						<div className="mb-2">
						  <div className="form-check">
						    <input
						      className="form-check-input"
						      type="checkbox"
						      id="addToMultiAlerts"
						      checked={addToMultiAlerts}
						      onChange={e => setAddToMultiAlerts(e.target.checked)}
						    />
						    <label className="form-check-label" htmlFor="addToMultiAlerts">
						      Add selected domain/sub domains to the selected alerts
						    </label>
						  </div>
						  <div className="form-check">
						    <input
						      className="form-check-input"
						      type="checkbox"
						      id="addToRoutingTableMultiAlert"
						      checked={addToRoutingTableMultiAlert}
						      onChange={e => setAddToRoutingTableMultiAlert(e.target.checked)}
						    />
						    <label className="form-check-label" htmlFor="addToRoutingTableMultiAlert">
						      Add records in the routing table
						    </label>
						  </div>
						  <div className="form-check">

						  <input
						    type="checkbox"
						    className="form-check-input"
						    id="selectNodeHierarchyMultiAlert"
						    checked={selectNodeHierarchyMultiAlert}
						    onChange={handleNodeHierarchyCheckboxMultiAlert}
						  />

						    <label className="form-check-label" htmlFor="selectNodeHierarchyMultiAlert">
						      Select Node(s) from Node Hierarchy And add these Domain/Sub Domain to them
						    </label>
						  </div>
						  <div className="mb-3">
						    {!selectNodeHierarchyMultiAlert && (
						      <button
						        type="button"
						        className="btn btn-sm btn-danger"
								onClick={handleResolveRoutingMulti}
						        
						      >
						        Resolve Routing - Multiple Alerts
						      </button>
						    )}
						    {selectNodeHierarchyMultiAlert && (
						      <button
						        type="button"
						        className="btn btn-sm btn-warning"
								onClick={handleContinueResolutionMultipleAlerts}						        
						      >
						        Continue With Routing Resolution - Multiple Alerts
						      </button>
						    )}
						  </div>
						</div>
	
					<div style={{ overflowX: 'auto', maxWidth: '100%' }}>
					   <table className="table table-bordered table-striped" id="resolver_table_alertwise">
					    <thead>
					      <tr>
						    <th >Select Domain</th>
						    <th >Select Subdomain</th>
					        {parentHeaders.map((k, i) => (
					          <th key={i}>{k}</th>
					        ))}
					      </tr>
					    </thead>

						<tbody>
						  {alertRoutingSummaryRows.map((rowObj, idx) => (
						    <React.Fragment key={idx}>
						      {/* Parent row with domain and subdomain dropdowns */}
						      <tr className="table-primary">
						        {/* Domain dropdown */}
						        <td>

								<select
								  value={
								    summaryNewDomainInputIdx === idx
								      ? -999
								      : rowObj.main.domain_id || rowObj.main.domainId || ''
								  }
								  className="form-select " 
								  style={{ width: 'auto' }}

								  onChange={e => {
								    const value = e.target.value;
									
								    if (value === '-999') {
										///
								      setSummaryNewDomainInputIdx(idx);
								      setSummaryNewDomainName('');
								      setAlertRoutingSummaryRows(prev =>
								        prev.map((row, i) =>
								          i === idx
								            ? { ...row, main: { ...row.main, domain_id: -999, domainId: -999, domain: '', domainName: '', subDomainId: '', subdomain: '' } }
								            : row
								        )
								      );
								      setTab2SubDomainLists(prev => ({ ...prev, [idx]: [] }));
								    } else {
								      setSummaryNewDomainInputIdx(null);
								      // Find domain name from tab2DomainList
								      const selectedDomain = tab2DomainList.find(d => String(d.domainId) === String(value));
									  const selName = selectedDomain ? selectedDomain.domainName : '';
									  setSelectedDomainName(selName);
									  setAlertRoutingSummaryRows(prev =>
								        prev.map((row, i) =>
								          i === idx
								            ? {
								                ...row,
								                main: {
								                  ...row.main,
								                  domain_id: value,
								                  domainId: value,
								                  domain: selectedDomain?.domainName || '',
								                  domainName: selectedDomain?.domainName || '',
							                  subDomainId: '',
								                  subdomain: ''
								                }
								              }
								            : row
								        )
								      );
								      loadSubdomainForAlertwise(value, idx);
								      setTab2SubDomainLists(prev => ({ ...prev, [idx]: [] }));
								    }
								  }}

								>
								<option value="">Select Domain</option>
								<option key="-999" value="-999">Add A New Domain</option>
								  {tab2DomainList.map(domain => (
									
									
								    <option key={domain.domainId} value={domain.domainId}>
								      {domain.domainName}
								    </option>
									
								  ))}
								</select>

						        </td>
						        {/* Subdomain dropdown */}
						        <td >
								<select
								   value={rowObj.main.subDomainId || ''}
								   className="form-select"
								   style={{ width: 'auto' }}
								   onChange={e => {
								     const value = e.target.value;
								     if (value === '-9999') {
								       setSummaryNewSubDomainInputIdx(idx);
								       setSummaryNewSubDomainName('');
								     } else {
								       setSummaryNewSubDomainInputIdx(null);
								       setSummaryNewSubDomainName('');
								       setAlertRoutingSummaryRows(prev =>
								         prev.map((row, i) =>
								           i === idx
								             ? { ...row, main: { ...row.main, subDomainId: value, subdomain: (tab2SubDomainLists[idx] || []).find(s => String(s.subDomainId) === value)?.subDomainName || '' } }
								             : row
								         )
								       );
								     }
								   }}
								 >
								  <option value="">Select Subdomain</option>
								  <option key="-9999" value="-9999">Add A New Subdomain</option>
								   {(tab2SubDomainLists[idx] || []).map(sub =>
									<option key={sub.subDomainId} value={sub.subDomainId}>{sub.subDomainName}</option>
								    
								 )}
								 </select>
						        </td>
						        {/* Other parent columns */}
						        {parentHeaders.map((k, i) => (
						          <td className='text-nowrap' key={i}>
						            {k === 'create_date' && rowObj.main[k]
						              ? format(new Date(rowObj.main[k]), 'MM/dd/yyyy')
						              : rowObj.main[k]}
						          </td>
						        ))}
						      </tr>
						      {/* Nested rows table */}
						      {rowObj.nested.length > 0 && (
						        <tr>
						          <td colSpan={parentHeaders.length + 2} style={{ padding: 0, background: "#f8f9fa" }}>
						            <table className="table table-sm table-bordered mb-0">
						              <thead>
						                <tr>
						                  <th className="delete-col">Delete</th>
						                  <th className="number-col">No.</th>
						                  {nestedHeaders.map((k, j) => (
						                    <th key={j}>{k}</th>
						                  ))}
						                </tr>
						              </thead>
						              <tbody>
						                {rowObj.nested.map((nested, j) => (
						                  <tr key={j}>
						                    <td >
											<span 
											onClick={async () => {
												 const confirmed = await PopupService.getInstance().showConfirm(
						                            'Do you want to remove this row from routing resolution?'
						                          );
						                          if (confirmed) {
						                            handleDeleteNestedRow(idx, nested.mongo_id);
						                          }
						                        }}
											  style={{ cursor: 'pointer', color: 'red' }} title="Exclude from these routing resolutions." class="badge bg-info text-light">
						                      <i className="fa fa-trash text-light"></i>
											  &nbsp;Exclude</span>
						                    </td>
						                    <td>{j + 1}</td>
						                    {nestedHeaders.map((k, i) => (
						                      <td key={i}>
						                        {k === 'create_date' && nested[k]
						                          ? format(new Date(nested[k]), 'MM/dd/yyyy')
						                          : nested[k]}
						                      </td>
						                    ))}
						                  </tr>
						                ))}
						              </tbody>
						            </table>
						          </td>
						        </tr>
						      )}
						    </React.Fragment>
						  ))}
						</tbody>

					  </table>
					</div> 
					</> 
					)}
					</div>
					</div>

				
				  )}
				  <br/>
				  <div id="client_unresolved">
				  <div className='card'>
				   <div className='card-header'> Unresolved Routing by Client - {selectedClientId}</div>
				   <div className='card-body'>
				   {/*start of body for unresolved */}
				   <div className="mb- d-flex align-items-center">
					      <input
					        type="text"
					        className="form-control w-auto me-2"
					        placeholder="Search..."
					        value={clientUnresolvedSearch}
					        onChange={e => setClientUnresolvedSearch(e.target.value)}
					      />
					      <button className="btn btn-secondary me-2" onClick={handleClientUnresolvedSearch}>Search</button>

						  <button
						    className="btn btn-secondary me-2"
						    onClick={() => {
						      setClientUnresolvedSearch('');
						      fetchClientUnresolved(selectedClientId, 1, clientUnresolvedPageSize, '');
						    }}
						  >
						    Clear
						  </button>

					    </div>
						<br/>
						<div style={{ overflowX: 'auto', maxWidth: '100%' }}>
					    <table className="table table-bordered table-striped">
						 
					      <thead>
					        <tr>
					         
					          {clientUnresolvedHeaders.map((h, idx) => (
					            <th key={idx}>{h}</th>
					          ))}
					        </tr>
					      </thead>

						  <tbody>
						    {clientUnresolvedData.map((row, idx) => (
						      <React.Fragment key={idx}>
						        <tr>
						          

								  {clientUnresolvedHeaders.map((h, i) => {
								    if (h === 'No.') {
								      return <td key={i}>{idx + 1 + (clientUnresolvedPage - 1) * clientUnresolvedPageSize}</td>;
								    }
								    if (h === 'actions') {
								      return (
								        <td  key={i}>
								          <i
										    className={expandedRows[idx] ? "fa fa-minus" : "fa fa-plus"}
								            style={{ cursor: 'pointer' }}
								            onClick={() => handleExpandRow(row.mongo_id, row.client_id, idx)}
								          />
								        </td>
								      );
								    }
								    let val = row[h];
								    if (h === 'create_date' && val) {
								      const dateObj = typeof val === 'string' ? new Date(val) : val;
								      val = !isNaN(dateObj) ?
								        `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()}`
								        : '';
								    } else if (val && typeof val === 'object') {
								      val = JSON.stringify(val);
								    }
								    return <td className='text-nowrap' key={i}>{val !== undefined ? val : ''}</td>;
								  })}

						        </tr>

								{expandedRows[idx] && (
									
								  <tr>
								    <td colSpan={clientUnresolvedHeaders.length + 1}>
								      <table className="table table-sm table-bordered table-striped mb-0">
								        <thead>
								          <tr>

										  <th>
										    <input
										      type="checkbox"
										      checked={
										        nestedAlerts[idx] &&
										        nestedAlerts[idx].length > 0 &&
										        selectedNestedIds[idx] &&
										        selectedNestedIds[idx].length === nestedAlerts[idx].length
										      }
										      indeterminate={
										        selectedNestedIds[idx] &&
										        selectedNestedIds[idx].length > 0 &&
										        selectedNestedIds[idx].length < nestedAlerts[idx].length
										      }
										      onChange={e => {
										        if (e.target.checked) {
										          setSelectedNestedIds(prev => ({
										            ...prev,
										            [idx]: nestedAlerts[idx].map(alert => alert.mongo_id)
										          }));
										        } else {
										          setSelectedNestedIds(prev => ({ ...prev, [idx]: [] }));
										        }
										      }}
										    />
										  </th>

								            <th>No.</th>
								            {nestedAlerts[idx] && nestedAlerts[idx][0] &&
								              Object.keys(nestedAlerts[idx][0])
								                .filter(k => k !== 'mongo_id' && k !== '_id' && k !== 'status')
								                .map((k, j) => (
								                  <th key={j + 1}>{k}</th>
								                ))}
								            <th>Status</th>
								          </tr>
								        </thead>
								        <tbody>
								          {nestedAlerts[idx] && nestedAlerts[idx].map((alert, j) => {
								            // Get keys except mongo_id, _id, and status
								            const keys = Object.keys(alert).filter(k => k !== 'mongo_id' && k !== '_id' && k !== 'status');
								            return (

												<tr
												  key={j}
												  className={
												    alert.status === 'UNRESOLVED'
												      ? 'table-warning'
												      : alert.status === 'RESOLVED'
												      ? 'table-success'
												      : ''
												  }
												>

												<td>
												  <input
												    type="checkbox"
												    value={alert.mongo_id}
												    checked={selectedNestedIds[idx]?.includes(alert.mongo_id) || false}
												    onChange={e => {
												      setSelectedNestedIds(prev => {
												        const current = prev[idx] || [];
												        if (e.target.checked) {
												          return { ...prev, [idx]: [...current, alert.mongo_id] };
												        } else {
												          return { ...prev, [idx]: current.filter(id => id !== alert.mongo_id) };
												        }
												      });
												    }}
												  />
												</td>


												<td>{j + 1}</td>
												{keys.map((key, k) => (
												  <td key={k + 1}>
												    {key === 'create_date'
												      ? (alert[key] ? format(new Date(alert[key]), 'MM/dd/yyyy') : '')
												      : alert[key] !== undefined
												        ? highlightText(alert[key], clientUnresolvedSearch)
												        : ''}
												  </td>
												))}

												  <td>{alert.status !== undefined ? alert.status : '-'}</td>
												</tr>

								            );
								          })}
								        </tbody>
								      </table>
                      
									  {clientUnresolvedData.length > 0 && (

										<div className="d-flex justify-content-center mt-3">
										  <button
										    className="btn btn-warning btn-sm me-2"
										    onClick={handleDiscardForCleanup}
										    disabled={
										      !Object.values(selectedNestedIds).some(arr => arr && arr.length > 0)
										    }
										  >
										    Discard for Cleanup
										  </button>
										  <button
										    className="btn btn-info btn-sm"
										    onClick={handleStartRoutingResolutionAlertWise}
										    disabled={
										      !Object.values(selectedNestedIds).some(arr => arr && arr.length > 0)
										    }
										  >
										    Start Routing Resolution - Multiple Alerts
										  </button>
										</div>

									  )}

								    </td>
								  </tr>
								)}

						      </React.Fragment>
						    ))}
						  </tbody>

					    </table>
						</div>
						<nav>
						  <ul className="pagination mb-0">
						    <li className={`page-item${clientUnresolvedPage === 1 ? ' disabled' : ''}`}>
						      <button className="page-link text-secondary" onClick={() => handleClientUnresolvedPageChange(1)} disabled={clientUnresolvedPage === 1}>&laquo;</button>
						    </li>
						    <li className={`page-item${clientUnresolvedPage === 1 ? ' disabled' : ''}`}>
						      <button className="page-link text-secondary" onClick={() => handleClientUnresolvedPageChange(clientUnresolvedPage - 1)} disabled={clientUnresolvedPage === 1}>Previous</button>
						    </li>
						    {pageNumbers.map(page => (
						      <li key={page} className={`page-item${clientUnresolvedPage === page ? ' active' : ''}`}>
						        <a
						          href="#"
						          className="page-link"
						          onClick={e => { e.preventDefault(); handleClientUnresolvedPageChange(page); }}
						        >
						          {page}
						        </a>
						      </li>
						    ))}
						    <li className={`page-item${clientUnresolvedPage === clientUnresolvedTotalPages ? ' disabled' : ''}`}>
						      <button className="page-link text-secondary" onClick={() => handleClientUnresolvedPageChange(clientUnresolvedPage + 1)} disabled={clientUnresolvedPage === clientUnresolvedTotalPages}>Next</button>
						    </li>
						    <li className={`page-item${clientUnresolvedPage === clientUnresolvedTotalPages ? ' disabled' : ''}`}>
						      <button className="page-link text-secondary" onClick={() => handleClientUnresolvedPageChange(clientUnresolvedTotalPages)} disabled={clientUnresolvedPage === clientUnresolvedTotalPages}>&raquo;</button>
						    </li>
							<li>
				            <div className="d-flex align-items-center ms-2">
				              <input
				                type="number"
				                min="1"
				                max={clientUnresolvedTotalPages}
								value={clientUnresolvedJumpPage}
								onChange={e => setClientUnresolvedJumpPage(e.target.value)}
				                onKeyDown={e => { if (e.key === 'Enter') handleClientUnresolvedJumpPage(); }}
				                className="form-control"
				                style={{ width: 80, marginRight: 4 }}
				                placeholder="Page #"
				                aria-label="Go to page"
				              />
				              <button className="btn btn-secondary btn-sm" onClick={handleUrGotoPage} type="button">Go</button>
				            </div>
				          </li>
						  <li>
						  <span className="ms-3">Page {clientUnresolvedPage} of {clientUnresolvedTotalPages} - {clientUnresolvedTotal} Records</span>
						  </li>
						  </ul>
						</nav>
					  </div>
				   {/* end  */}
				   </div>
				 </div>						    			         
			    </div>
			  )}
			    
		  </div>			
		</div>		  
		</div>		  
		</div>
      </div>
      <Footer />
    </>
  );
};

export default ResolveRouting;
